export default __webpack_public_path__ + "static/media/sound-off.7d2bfdd8.svg";